import React from "react";
import "./Button.css";

export default function BotonAgregar({
  texto,
  onClick,
  className = "boton-agregar",
}) {
  return (
    <button
      type="button"
      className={className}
      onClick={(e) => {
        e.stopPropagation();
        onClick && onClick(e); 
      }}
    >
      {texto}
    </button>
  );
}
